<ul class="lang-dropdown-wrapper">
  <li><a [routerLink]="[routes.userProfile, userData?.FormattedID]"><app-editprofileicon></app-editprofileicon>My Profile</a></li>
  <li><a (click)="loginS.logout()"><app-logouticon></app-logouticon>Logout</a></li>
</ul>